// extracted by mini-css-extract-plugin
module.exports = {"cardItem":"CardWrapper_cardItem__zTZ4l"};